import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch";
import { selectTabularSettingsState } from "../../../../../store/selectors/fieldsStateSelectors";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks";
import type {
  TabularGeneralSettings,
  TabularSubtotalLabelPosition,
} from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  disabled?: boolean;
}

const SubtotalPosition = ({ disabled }: Props) => {
  const settingsAreaValues = useSelector(selectTabularSettingsState);
  const dispatch = useAppDispatch();

  const handleSubtotalLabelPositionChange = (
    oldValue: TabularSubtotalLabelPosition,
    newValue: TabularSubtotalLabelPosition
  ) => {
    const payload: Partial<TabularGeneralSettings> = { subtotalLabelPosition: newValue };
    // We set the default prefix if the user is changing the position from None
    // and the prefix and suffix are empty
    if (
      oldValue === "None" &&
      !settingsAreaValues.subtotalLabelFormatPrefix?.length &&
      !settingsAreaValues.subtotalLabelFormatSuffix?.length
    ) {
      payload.subtotalLabelFormatPrefix = "Subtotals of";
    }
    dispatch(fieldsStateActions.updateSettings({ settings: payload }));
  };

  return (
    <ToggleButtonGroup
      fullWidth
      exclusive
      color={"primary"}
      value={settingsAreaValues.subtotalLabelPosition}
      onChange={(_, newValue: TabularSubtotalLabelPosition) => {
        if (newValue === null) {
          return;
        }
        handleSubtotalLabelPositionChange(settingsAreaValues.subtotalLabelPosition, newValue);
      }}
      sx={{ "& .MuiToggleButton-root": { py: 0.3, fontWeight: 400 } }}
      disabled={disabled}
    >
      <ToggleButton value="None">None</ToggleButton>
      <ToggleButton value="Leading">Leading</ToggleButton>
      <ToggleButton value="Group">Group</ToggleButton>
      <ToggleButton value="Trailing">Trailing</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default SubtotalPosition;
